import { cn } from '@/components/ui/cn';

/** Logo : carré arrondi à bordure or, étoile au trait (design « Zakat Layène »). */
export function Logo({ size = 40, className }: { size?: number; className?: string }) {
  return (
    <span
      className={cn('flex shrink-0 items-center justify-center border-[1.5px] border-gold-500', className)}
      style={{ width: size, height: size, borderRadius: Math.round(size * 0.3) }}
      aria-hidden="true"
    >
      <svg width={Math.round(size * 0.55)} height={Math.round(size * 0.55)} viewBox="0 0 24 24" fill="none" stroke="#E7C873" strokeWidth="1.6" strokeLinejoin="round">
        <path d="M12 2l2.6 5.4L20 8.2l-4 4 1 5.8L12 15.3 7 18l1-5.8-4-4 5.4-.8z" />
      </svg>
    </span>
  );
}
